@if ($isInactive()) {
    <cm-hint [hintType]="HintTypes.Warning">
        <ng-container cm-text>
            The jobs system is currently <strong>inactive</strong> — no jobs will be picked up or processed. This is most likely due to an active deployment and
            should resolve on its own in a moment. If it persists, please contact the dev team.
        </ng-container>
    </cm-hint>
}
